module.exports = __webpack_public_path__ + "img/manifestation-journal_B09PYZL8DY.f0ce2bcb.jpg";